import { render } from "./ListaMuzee.vue?vue&type=template&id=56666d77"
import script from "./ListaMuzee.vue?vue&type=script&lang=js"
export * from "./ListaMuzee.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\cazino\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__